import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import * as _ from 'lodash';
import * as io from 'socket.io-client';
import { EfoEgiService } from './egi.service';
import { map } from 'rxjs/operators';
import { EflowService } from './eflow.service';
import { ElevationService } from './elevation.service';
import { AccessService } from '../../core/services/access.service';

@Injectable({
  providedIn: 'root',
})
export class RobomailService {
  //private socketUrl = 'http://socket1.carbrewer.com:3002';
  private socketUrl = 'http://socket.epiphanex.com:5000';
  private socket;

  constructor(
    private efoEgi: EfoEgiService,
    private eflow: EflowService,
    private elevation: ElevationService,
    private accessApi: AccessService,
  ) {
    this.socket = io(this.socketUrl, {
      transports: ['websocket'],
    });
    this.socket.on('connect', () => {
      this.socket.emit(
        'new-message',
        'portal service connected: email-oversight.service',
      );
    });
  }
  getRobomailBroadcastReport(vipcode): Observable<any> {
    return this.efoEgi.getData('/robomail/getRobomailBroadcastReport', {
      vipcode: vipcode,
    });
  }

  getRobomailTargetResponseReport(vipcode): Observable<any> {
    return this.efoEgi.getData('/robomail/getRobomailTargetResponseReport', {
      vipcode: vipcode,
    });
  }
  getRobomailCampaignLinks(vipcode): Observable<any> {
    return this.efoEgi.getData('/robomail/getRobomailCampaignLinks', {
      vipcode: vipcode,
    });
  }
  getRobomailCampaignActivityReportAll(select_month): Observable<any> {
    return this.efoEgi
      .getData('/robomail/getRobomailCampaignActivityReportAll', {
        select_month: select_month,
      })
      .pipe(
        map((rs) => {
          _.each(rs, (d) => {
            d.clicked_cnt = _.sum(_.map(d.results, 'clicked'));
            d.viewed_cnt = _.sum(_.map(d.results, 'viewed'));
          });
          return rs;
        }),
      );
  }
  getRobomailDeliverabilityReport(): Observable<any> {
    return this.efoEgi.getData('/robomail/getRobomailDeliverabilityReport', {});
  }
  getRobomailActivityReport(vipcode): Observable<any> {
    return this.efoEgi.getData('/robomail/getRobomailActivityReport', {
      vipcode: vipcode,
    });
  }
  getRobomailDeliverability(): Observable<any> {
    return this.efoEgi.getData('/sdb/robomailDeliverability', {});
  }

  getUsedIpGroups(): Observable<any> {
    return this.efoEgi.getData('/robomail/getUsedIpGroups', {});
  }

  public getRobomail = () => {
    return new Observable((observer) => {
      this.socket.on('robomail', (data) => {
        observer.next(data);
      });
    });
  };

  getAvailableBrands(): Observable<any> {
    return this.elevation.getData('/robomail/getAvailableBrands', {});
  }

  getEmailBodyFilesByBrand(brand, type, account_num?): Observable<any> {
    return this.elevation.getData(
      '/robomail/emailBodyFilesByBrand',
      {
        brand: brand,
        type: type,
        account_num: account_num,
      },
      { headers: this.accessApi.apiHeader },
    );
  }

  getEmailBodyFilesByAccount(account_num, date): Observable<any> {
    return this.elevation.getData(
      '/robomail/emailBodyFilesByAccount',
      {
        account_num: account_num,
        date: date,
      },
      { headers: this.accessApi.apiHeader },
    );
  }
}
